import { getDataFromPackManager } from 'packmanager-communication-lib';

export async function getPacksInfo() {
    const accessToken = (await getDataFromPackManager('accountToken')) as string;
    const packId = (await getDataFromPackManager('packId')) as string;

    return {
        accessToken: accessToken || 'dev-access-token',
        packId: packId || 'dev-pack-id',
    };
}
